import React, { useEffect, useState } from 'react';
import { StyledDiv, StyledInfiniteScroll } from '../../Theme/CommonStyled';
import { getNotificationData } from '../../Services/notification.service';
import LoadingSpinner from '../Common/LoadingSpinner';
import Title from '../Common/Title';
import NotificationItem from './NotificationItem';
import { normalizeNotificationData } from '../../Utils/notification.util';
import useLandingStore from '../../Store/Landing';

const Notification = () => {
  const landingData = useLandingStore((state) => state.landingData);

  const [notificationData, setNotificationData] = useState({});
  const [dataLength, setDataLength] = useState(20);
  const [hasMore, setHasMore] = useState(true);

  const getMoreData = () => {
    setTimeout(async () => {
      const response = await getNotificationData({
        clubBranchId: landingData.branchId,
        skip: dataLength - 20,
        take: 20
      });

      response &&
        setNotificationData({
          ...notificationData,
          ...normalizeNotificationData(response)
        });

      if (response?.length !== 20) {
        setHasMore(false);
      } else {
        setDataLength((dataLength) => dataLength + 20);
        setHasMore(true);
      }
    }, 500);
  };

  useEffect(() => {
    !Object.keys(notificationData).length && getMoreData();
  }, []);

  return (
    <StyledDiv pt={9} px={8} pb={18}>
      {(
        <StyledInfiniteScroll
          scrollableTarget="notification-container"
          next={getMoreData}
          loader={
            <StyledDiv
              width="100%"
              display="flex"
              justifyContent="center"
              mb={5}>
              <LoadingSpinner width={'20px'} height={'20px'} type="green" />
            </StyledDiv>
          }
          hasMore={hasMore}
          dataLength={dataLength}>
          {notificationData &&
            Object.keys(notificationData).map((item) => (
              <StyledDiv key={item}>
                <Title title={item} mb={6} fontSize={2} />
                {notificationData[item].map((notification) => (
                  <NotificationItem
                    key={notification.smsId}
                    data={notification}
                  />
                ))}
              </StyledDiv>
            ))}
        </StyledInfiniteScroll>
      ) || hasMore}
    </StyledDiv>
  );
};

export default Notification;
